export class Question {
  key: string = "";
  id: string = "";
  type: string = "";
  sector: string = "";
  value: string = "";
  tag: string = "";
  newField: boolean = true;
  templateOptions: templateOptions = new templateOptions();
  complete: boolean = false;
  wrappers: string[];
  fieldGroupClassName: string;
  fieldGroup: Question[];
  className: string;
  hideExpression: string;
  forOption: string;
  tabPosition: number;
  questionPosition: number;
  isLockDownEdit: boolean = false;
  linkedHealthAndSafetyResponsibilitiesQuestion: string;
  checkboxLabel?: string;

  constructor(values: Object = {}) {
    Object.assign(this, values);
  }
}

export class templateOptions {
  label: string = "";
  required: boolean = false;
  options: any[];
  multipleOutputs: any[] = [];
}
